import React from "react";
import { Link } from "react-router-dom";

const HelpHero = () => {
  return (
    <div className="overflow-hidden">
      <div className="help--hero ">
        <div className="hero--cover h-full w-full ">
          <div className="container h-full flex items-center justify-center text-center">
            <div>
              <h2 className="roboto uppercase text-white ">
                <span className="text-pri-500 roboto">We</span> help
              </h2>
              <div className="text-white text-xl mb-7 max-w-3xl -mt-2">
                We give you the answers for your questions related to our limo
                service. If not satisfied contact us for more informations.
              </div>
              <Link
                to="/book-now-a-chauffeur-service"
                className="btn2 text-base"
              >
                Book Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpHero;
